exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".h-100p[data-v-6b7f7d8e]{height:100%}.header-table-divider[data-v-6b7f7d8e]{margin-top:2%}.btn-new-identity[data-v-6b7f7d8e]{background-color:#0032a0!important;color:#fff}.v-btn[data-v-6b7f7d8e]{text-transform:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6b7f7d8e","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/authandvideocall/AllAuthAndVideoCall.vue
// module id = 1019
// module chunks = 0